import {HttpClient, HttpResponse} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {defaultOptions, responseToObject} from '@emma-labs/shared/angular';
import {ENVIRONMENT, EnvironmentBroker} from '@emma-labs/shared/typescript';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {AgentLoginResult} from '../entities/agent-login-result';
import {AgentSession} from '../entities/agent-session';
import {handleHttpError} from '../utils/utility-constants';

@Injectable({
  providedIn: 'root',
})
export class AgentSessionApiService {
  basePath: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(ENVIRONMENT) readonly environment: EnvironmentBroker,
  ) {
    this.basePath = `${environment.apiBase}/sessions/agents`;
  }

  getAgentSession(sessionId: string): Observable<AgentSession> {
    const options = defaultOptions(sessionId).buildOptions();

    return this.http.get(`${this.basePath}/${sessionId}`, options).pipe(
      map((result) => responseToObject<AgentSession>(result as HttpResponse<string>)),
      catchError((error) => handleHttpError(error)),
    );
  }

  login(email: string, password: string): Observable<AgentLoginResult> {
    const body = {email: email, password: password};
    const options = defaultOptions('').buildOptions();

    return this.http.post(`${this.basePath}`, body, options).pipe(
      map((result) => responseToObject<AgentLoginResult>(result as HttpResponse<string>)),
      catchError((error) => handleHttpError(error)),
    );
  }

  validateMultifactorAuthenticationCode(
    email: string,
    password: string,
    code: string,
  ): Observable<AgentLoginResult> {
    const body = {email, password, code};
    const options = defaultOptions('').buildOptions();

    return this.http.post(`${this.basePath}/mfa`, body, options).pipe(
      map((result) => responseToObject<AgentLoginResult>(result as HttpResponse<string>)),
      catchError((error) => handleHttpError(error)),
    );
  }

  resendMultifactorAuthenticationCode(email: string): Observable<undefined> {
    const options = defaultOptions('').buildOptions();

    return this.http.post(`${this.basePath}/mfa/resend`, {email}, options).pipe(
      map(() => undefined),
      catchError((error) => handleHttpError(error)),
    );
  }

  logout(sessionId: string): Observable<undefined> {
    const options = defaultOptions(sessionId).buildOptions();

    return this.http.delete(`${this.basePath}/${sessionId}`, options).pipe(
      map(() => undefined),
      catchError((error) => handleHttpError(error)),
    );
  }
}
